export default __webpack_public_path__ + "static/media/ic_senegal.ec41bf1f.svg";